const defaultState = () => {};

const mutations = {
    setPricingPeriodUpdatedData(state, pricingPeriodUpdatedData) {
        Object.assign(state, pricingPeriodUpdatedData);
    },
    resetPricingPeriodUpdatedData(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    setPricingPeriodUpdatedData({ commit }, data) {
        commit('setPricingPeriodUpdatedData', data);
    },
    resetPricingPeriodUpdatedData({ commit }) {
        commit('resetPricingPeriodUpdatedData');
    },
};

const getters = {
    pricingPeriodData: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
